// openEHR RM model — BMM package org.openehr.rm.support
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import { TERMINOLOGY_SERVICE } from "./terminology.ts";

/**
 * A mixin class providing access to services in the external environment.
 */
export abstract class EXTERNAL_ENVIRONMENT_ACCESS extends TERMINOLOGY_SERVICE {
}
